export default __webpack_public_path__ + "static/media/chest-4.a715d550.webp";